// Environment feature flags — a "dark launch" layer ABOVE entitlements.
//
// Entitlements (shared/entitlements.ts) answer "can THIS user use the feature?"
// (per-user plan). Feature flags answer "does this feature EXIST in this
// environment yet?" A flag that is OFF hides the surface entirely, regardless of
// plan — so an in-flux feature can ship to prod dormant and graduate later.
//
// The flag VALUES live in Cloudflare Flagship (one app per environment): the
// worker evaluates them via its `env.FLAGS` binding; the SPA reads them from
// `GET /api/v1/flags` (it must not hold a Cloudflare token). Both agree on the
// key set below. Evaluation is fail-closed to `false` (hidden) everywhere.

export const FEATURE_FLAGS = [
  "analytics",
  "resume",
  "skills",
  "billing",
  "teams",
] as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[number];

/** The wire shape of GET /api/v1/flags → { flags: { analytics: bool, ... } }. */
export type FlagMap = Record<FeatureFlag, boolean>;

/** All-hidden map — the fail-closed default (binding absent / fetch failed / loading). */
export const ALL_FLAGS_OFF: FlagMap = {
  analytics: false,
  resume: false,
  skills: false,
  billing: false,
  teams: false,
};
